import React from "react";
import Classes from "./Footer.module.css";
import { scrollToElement } from "../../../utils/scrollToElement";
import { useLocation, useNavigate } from "react-router-dom";

export default function Footer() {
    const navigateTo = useNavigate();
    const location = useLocation();

    const handleScrollOrNavigate = (id, offset = 0) => {
        if (location.pathname !== '/') {
            navigateTo('/', { state: { scrollTo: { id, offset } } });
        } else {
            scrollToElement(id, offset);
        }
    };

    return (
        <footer className={Classes.footer}>
            <div className={Classes.topArea}>
                <div className={Classes.leftBlock}>
                    <a href="/" style={{ height: '2.2rem', width: 'fit-content' }} >
                        <h3 style={{ color: '#1F1F22', fontSize: '25px' }}  >Mentr</h3>
                    </a>
                    <div className={Classes.ctaCard}>
                        <p>
                            Talk to a mentor who is where you want to
                            be on your career journey.
                        </p>
                        <button onClick={() => { navigateTo('/join') }} > <h5>Get Started for Free</h5> </button>
                    </div>
                </div>

                {/* Right: Footer navigation columns */}
                <div className={Classes.navColumns}>
                    <div>
                        <h4>Product</h4>
                        <ul>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('home', 0) }} > Demo </h5> </li>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('howItWorks', 20) }} >How it Works </h5> </li>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('features', 20) }} > Features </h5> </li>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('pricing', 25) }} > Pricing </h5> </li>
                        </ul>
                    </div>
                    <div>
                        <h4>Company</h4>
                        <ul>
                            <li> <h5>Blog</h5> </li>
                            <li> <h5 onClick={() => { handleScrollOrNavigate('faq', -50) }}  >FAQ</h5> </li>
                            <li onClick={() => { navigateTo('/contact-us') }}> <h5>Contact</h5> </li>
                        </ul>
                    </div>
                    <div>
                        <h4>Legal</h4>
                        <ul>
                            <li> <a href="/data-security" target='_blank' > <h5>Data Security</h5> </a> </li>
                            <li> <a href="/terms-of-service" target='_blank' > <h5>Terms of Use</h5> </a> </li>
                            <li> <a href="/privacy-policy" target='_blank' > <h5>Privacy Policy</h5> </a> </li>
                        </ul>
                    </div>
                </div>
            </div>

            {/* Divider line */}
            <div className={Classes.divider}></div>

            {/* Bottom bar: copyright + social */}
            <div className={Classes.bottomBar}>
                <span><h5>© 2025 Mentr. All rights reserved.</h5></span>
                {/* Example LinkedIn icon or any social link */}
                <a
                    href="https://www.linkedin.com/company/evolvionio"
                    target="_blank"
                    rel="noopener noreferrer"
                    className={Classes.socialLink}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M100.3 448H7.4V148.9h92.9zM53.8 108.1C24.1 108.1 0 83.5 0 53.8a53.8 53.8 0 0 1 107.6 0c0 29.7-24.1 54.3-53.8 54.3zM447.9 448h-92.7V302.4c0-34.7-.7-79.2-48.3-79.2-48.3 0-55.7 37.7-55.7 76.7V448h-92.8V148.9h89.1v40.8h1.3c12.4-23.5 42.7-48.3 87.9-48.3 94 0 111.3 61.9 111.3 142.3V448z" /></svg>
                </a>
            </div>
        </footer>
    );
}
